import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '../../../applicationinfraestructure/services/authentication.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.css']
})
export class UpdateUserComponent implements OnInit {

  userForm : FormGroup
  constructor(@Inject(MAT_DIALOG_DATA) public data : any,
  public dialogRef : MatDialogRef<UpdateUserComponent>,
  private formBuilder :FormBuilder,
  private authService: AuthenticationService,
  private toaster: ToastrService) { }

  ngOnInit(): void {
    this.initForm()
    this.initData()
  }

  initForm(){
      this.userForm = this.formBuilder.group({
        email:['',[Validators.required,Validators.email,this.emailMinCaracter]],
        phone:['',[Validators.required]]
      })
    }

    emailMinCaracter(control: AbstractControl): ValidationErrors | null {
      const email = control.value;
      if (!email) return null;
      const parts = email.split('@');
      
      if (parts.length === 2 && parts[0].length >= 3) {
          return null; 
      } else {
          return { emailMinCaracter: true };
      }
  }

  initData(){
    this.userForm.setValue({
      email:this.data.emailVerificado,
      phone:this.data.celular
    })
  }

    validateEmail(field:string, type:string){
     if (field != null) {
      return this.userForm.get(field).hasError(type)
     }
    }
  
  updateUser(){
    if (this.userForm.valid) {
      this.data.emailVerificado = this.userForm.get('email').value
      this.data.celular = this.userForm.get('phone').value
      this.authService.updateUsuarioBackend(this.data).subscribe((result)=>{
        if (result.success) {
          this.toaster.success('', 'Se ha guardado con éxito!.');
          this.dialogRef.close()
        }
      })
    }else{
      alert("Verique el formulario")
      console.log(this.userForm.valid)
    }
    
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
